import {Component, ViewChild} from "@angular/core";
import {ActivityModalEvent, ACTIVITY_STATUS, ActivityEventData, ActivityEvent} from "../event/ActivityEvent";
import {ComponentBase} from "../base/ComponentBase";
import {Scilearn} from "../constants";
import {ModalConfig} from "../services/notification/modal.config";
import {EventBus} from "../event/EventBus";
import {RaVersion} from "../services/configuration/ra.version";
import {AudioQueueService} from "../services/audio-playback/audioqueue.service";
import {TimerStrategy} from "../services/configuration/timer.config";
import {ClientConfiguration} from "../services/configuration/client.config";
import {filter} from "rxjs/operators";

@Component({
    selector: "help",
    templateUrl:"./help.component.html",
    styleUrls: ["./help.component.scss"]
})

export class HelpComponent extends ComponentBase {

    private modalType: string = Scilearn.HELP_MODAL;
    public activeModal: boolean = false;
    public source: string = "resources/video-tutorial-ra-plus-120417.mp4";

    constructor(private modalConfig:ModalConfig,
                private audioQueueService: AudioQueueService,
                private eventBus:EventBus,
                private config:ClientConfiguration) {
        super("HelpComponent");
        this.listenToModalEvents();
    }

    private listenToModalEvents(): void {
        // event filter for user clicking a link to display
        let activitySubscription = this.eventBus.pipe(filter(event => event instanceof ActivityModalEvent)).subscribe((event:ActivityModalEvent) => {
            if (event.status === ACTIVITY_STATUS.modal_open && event.data.type === this.modalType) {
                this.openModal();
            }
        });

        this.subscriptions.push(activitySubscription);
    }


    private openModal(): void {

        if (this.config.getHelpUrl()) {
            this.source = "https://racontent.s3.us-west-1.amazonaws.com/assets/help_video/cl_clearfluency_walkthrough_v2.mp4";
        }

        this.audioQueueService.reset().subscribe(() => {
            this.eventBus.startActivityEvent(new ActivityEventData({timing: TimerStrategy.tutorial}));
            this.activeModal = true;
        });
    }
    @ViewChild("helpVideoPlayer") videoPlayer: any;
    public closeModal(): void {
        this.eventBus.endActivityEvent(new ActivityEventData({timing: TimerStrategy.tutorial}));
        this.activeModal = false;
        this.videoPlayer.nativeElement.autoplay = false;
    }

}
